import React from 'react'
import { CTA } from 'src/components/framework/ui/cta'
import { useStockReportContext } from 'src/contexts/stock-report.context'

import * as styles from './analyst-chart.module.scss'

export const AnalystChart: React.FC = () => {
  const { report } = useStockReportContext()
  const { security } = report
  const [estimateDate1, estimateDate2] =
    report.financialSummary.meta.estimateDates

  return (
    <>
      <div className={'stk-text-align-c'}>
        <h3 className={'stk-text-h4 '}>
          EPS
          <span className={styles.analystChartDates}>
            &nbsp;{estimateDate1} / {estimateDate2}
          </span>
        </h3>
        <div style={{ position: 'relative' }}>
          <img
            src={
              'https://www.stockopedia.com/assets/conversion/images/eps_forecast_blurred.jpg'
            }
            width={370}
            height={109}
            loading={'lazy'}
            style={{ height: 'auto' }}
            alt={`Blurred out image of ${security.name} EPS forecast chart`}
          />
          <CTA includeLabel={false} />
        </div>
      </div>
    </>
  )
}
